import { Directive, HostListener, ElementRef, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, PatternValidator, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[appProvinceCode]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: ProvinceCodeDirective,
            multi: true,
        }
    ],
    standalone: false
})
export class ProvinceCodeDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors {
   return /AB|ON|QC|PQ|NS|NB|MB|BC|PE|SK|NL|NT|YT|NU/.test(control.value)
     ? null
     : { invalid : true };
 }
}